import { render, staticRenderFns } from "./StudentActivityTableRatingCell.vue?vue&type=template&id=0bb31e4b&scoped=true&"
import script from "./StudentActivityTableRatingCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableRatingCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableRatingCell.vue?vue&type=style&index=0&id=0bb31e4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb31e4b",
  null
  
)

export default component.exports